import React, { useEffect, useRef } from "react";
import { runtime } from "codeArt/common";
import ReactEcharts from "echarts-for-react";
import echarts from "echarts";
import { DashedPanel } from "codeArt/components/accessory";
import { getLoopMulticolorValue, theme } from "../Base";

export default class DonutChart extends React.Component {
  constructor(props) {
    super(props);
  }

  labelFormat(params) {
    let { data } = this.props;
    let name = params.name;
    let value = params.value;
    let percent = params.percent;
    let item =
      data.find(t => {
        return t.name == name;
      }) || {};

    value = item.format
      ? item.format(value, percent + "%")
      : `${(parseFloat(value) * 100).toFixed(0)}%`;

    return { name, value };
  }

  getOption() {
    let { data, tooltip, legend, radius, fontSize, label, grid, title, titleStyle } = this.props;
    let option = {};
    let my = this;

    if (title) {
      option.title = {
        text: title,
        textStyle: {
          fontSize: 16,
          fontWeight: 400,
          color: theme.color.dark,
          ...titleStyle
        }
      };
    }

    if (tooltip) {
      option.tooltip = {
        trigger: "item",
        formatter: function (params) {
          let { name, value } = my.labelFormat(params);
          let tip = `${name} : ${value}`;
          return tip;
        }
      };
    }

    if (legend) {
      if (runtime.pc && label) {
        //显示label就不显示legend 不然容易叠加在一起 不是很好看
      } else {
        let ldata = data.map((t, i) => {
          return t.name;
        });
        option.legend = {
          orient: "horizontal",
          left: "center",
          top: 5,
          data: ldata
        };
      }
    }

    option.color = data.map((t, i) => {
      return t.color || getLoopMulticolorValue(i);
    });

    option.series = {
      type: "pie",
      radius: radius,
      avoidLabelOverlap: false,
      label: {
        show: false,
        position: "center"
      },
      emphasis: {
        label: {
          show: true,
          fontSize: fontSize,
          fontWeight: "bold"
        }
      },
      labelLine: {
        show: true
      },
      data: data
    };

    option.grid = {}; //自定义图表两边留空
    option.grid = Object.assign(option.grid, grid);
    let single = data.length == 1;
    if (label && runtime.pc) {
      //移动端屏幕调小 label超出画布范围 所以在pc端才显示label
      let label = {
        formatter: function (params) {
          let { name, value } = my.labelFormat(params);
          let tip = single
            ? `  {b|${name}：}{b|${value}}  `
            : `  {b|${name}：}{per|${value}}  `;
          return tip;
        },
        rich: {
          b: {
            fontSize: 15,
            lineHeight: 30
          },
          per: {
            color: "#eee",
            backgroundColor: "#334455",
            padding: [2, 4],
            borderRadius: 2
          }
        }
      };

      if (single) {
        label.position = "center";
        label.rich.b.fontWeight = "bold";
      } else {
        label.backgroundColor = "#eee";
        label.borderColor = "#aaa";
        label.borderWidth = 1;
        label.borderRadius = 4;
      }

      option.series.label = label;
    }

    return option;
  }

  render() {
    return (
      <ReactEcharts
        option={this.getOption()}
        notMerge={true}
        lazyUpdate={true}
        className={"w-100 h-100"}
      />
    );
  }
}

DonutChart.defaultProps = {
  data: [],
  legend: true,
  tooltip: true,
  label: false,
  fontSize: "20",
  radius: runtime.pc ? ["45%", "75%"] : ["30%", "50%"]
};

DonutChart.propTypes = {};
